
import { defineComponent, ref, reactive, onBeforeMount, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { MutationNames, useStore } from "@/store";
import { getMockExamInfo, getMockExamAnswers } from "@/services";
import useMockExam from "@/hooks/useMockExam";
export default defineComponent({
  setup() {
    const _store = useStore();
    let noMockExamTxt = ref(""); // 暂无模拟测评!
    let examThree: any = reactive([]);
    let total = ref(1);
    let current_page = ref(1);
    let message = ref("");
    let activeExams = ref([]); // 所有考试基础信息
    let activeExam = ref(""); // 选中考试基础信息
    const { getExamPaper, showExamMessageBox } = useMockExam();
    const router = useRouter();
    const route = useRoute();
    const goToHome = () => {
      router.push({
        path: "/home",
      });
    };
    const goToExamRecord = () => {
      router.push({
        path: "/examRecord",
        query: { type: "mockExam" },
      });
    };
    const startExam = (examId: any) => {
      console.time("模拟考页面按钮点击时间0");
      console.time("模拟考页面数据准备时间1");
      let examInfo = { active_exam: undefined, answer_sheet: undefined };
      activeExams.value.forEach((exam: any) => {
        if (exam.id === examId) {
          activeExam.value = exam;
          examInfo.active_exam = exam;
          return;
        }
      });

      _store.commit(MutationNames.CHANGE_EXAMINFO, examInfo);
      console.log("examData11111", _store.state.examInfo);
      const exam = { examType: "exam" };
      console.timeEnd("模拟考页面数据准备时间1");
      console.time("模拟考页面跳转时间2");
      getExamPaper(exam).then(() => {
        router.push({
          path: "/mockPaper",
        });
      });

      // examType 0|自由模式 1｜集体开始
      // if (examType === 0) {
      //   router.push({
      //     path: "/freeMode",
      //     query: { examId },
      //   });
      // } else {
      //   router.push({
      //     path: "/unifiedMode",
      //     query: { examId, examDate },
      //   });
      // }
    };
    const next = () => {
      const endNum = Math.ceil(activeExams.value.length / 3);
      console.log("endNum", endNum);
      console.log("endNum1", current_page.value);
      if (current_page.value >= endNum) {
        message.value = "已经是最后一页";
        ElMessage.warning({
          offset: 100,
          message: message.value,
          type: "warning",
        });
      } else {
        current_page.value++;
        examThree.length = 0;
        const startIndex = current_page.value * 3 - 3;
        const endIndex = current_page.value * 3;
        examThree.push(...activeExams.value.slice(startIndex, endIndex));
      }
    };
    const previous = () => {
      if (current_page.value === 1) {
        message.value = "已经是第一页";
        ElMessage.warning({
          offset: 100,
          message: message.value,
          type: "warning",
        });
      } else {
        current_page.value--;
        examThree.length = 0;
        const startIndex = current_page.value * 3 - 3;
        const endIndex = current_page.value * 3;
        console.log("indexpre", startIndex, endIndex);
        examThree.push(...activeExams.value.slice(startIndex, endIndex));
      }
    };
    onBeforeMount(() => {
      getMockExamInfo().then((data: any) => {
        if (data.exams.length === 0) {
          noMockExamTxt.value = "暂无模拟测评!";
        } else {
          noMockExamTxt.value = "";
          activeExams.value = data.exams;
          examThree.push(...data.exams.slice(0, 3));
          if (data.exams.length > 0) {
            total.value = Math.ceil(data.exams.length / 3);
            if (total.value === 0) {
              total.value = 1;
            }
          }
        }
      });
    });

    onMounted(() => {
      console.log(888);
      console.timeEnd("模拟考列表加载时间");
    });

    return {
      noMockExamTxt,
      examThree,
      current_page,
      total,
      goToExamRecord,
      goToHome,
      startExam,
      next,
      previous,
    };
  },
});
